export enum MessageType {
    Answer = 1,
    Question = 2
}
